import { type IntlShape, type MessageDescriptor } from "react-intl";

import { messages } from "../components/messages.generated";

// Row titles for the BFF's server-side checks, matching the client-side rows' sentence case.
const CHECK_LABELS: Record<string, MessageDescriptor> = {
    CREATE_LENS: messages.serverCheckCreateLens,
    LOGO_READABLE: messages.serverCheckLogoReadable,
    PACKAGE_READABLE: messages.serverCheckPackageReadable,
    PUSH_LENS: messages.serverCheckPushLens,
    UPDATE_LENS: messages.serverCheckUpdateLens,
};

/** Localized title for a server check; unknown names fall back to a capitalized form of the name. */
export const describeWebLensCheckLabel = (intl: IntlShape, name: string): string => {
    const message = CHECK_LABELS[name];
    if (message) {
        return intl.formatMessage(message);
    }
    const words = name.toLowerCase().replaceAll("_", " ");
    return words.charAt(0).toUpperCase() + words.slice(1);
};
